import React, { Suspense } from 'react';
import Can from '../services/permisions/Can'

/* Main Layout */
const EmptyLayout = ({ children, ...rest }) => {
  return (
    <>
      {children}
    </>
  )
}

/*
  Private route wrapper
 */

export const EmptyLayoutRoute = ({ component: Component, permissions, ...rest }) => {
  if (!permissions) {
    return (
      <EmptyLayout>
        <Suspense fallback={<></>}>
          <Component {...rest} />
        </Suspense>
      </EmptyLayout>
    );
  }

  return (
    <Can I={permissions.type} a={permissions.name} withRedirect={true} >
      <EmptyLayout>
        <Suspense fallback={<></>}>
          <Component {...rest} />
        </Suspense>
      </EmptyLayout>
    </Can>
  );
};

